(() => {
  'use strict';
  if (window.NonypeResponsiveMedia) return;
  const mobile = matchMedia('(max-width: 749px)');
  function loadWithin(scope) {
    if (!mobile.matches) return;
    scope.querySelectorAll('img[data-nonype-mobile-src]').forEach((image) => {
      image.fetchPriority = 'auto';
      image.srcset = image.dataset.nonypeMobileSrcset;
      image.src = image.dataset.nonypeMobileSrc;
      delete image.dataset.nonypeMobileSrc;
      delete image.dataset.nonypeMobileSrcset;
    });
  }
  function observeGallery(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    if (!('IntersectionObserver' in window)) { loadWithin(gallery); return; }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && mobile.matches) loadWithin(entry.target);
      });
    }, { root: viewer, threshold: 0.05 });
    gallery.querySelectorAll('[data-media-id]').forEach((slide) => observer.observe(slide));
    return observer;
  }
  document.addEventListener('pointerover', (event) => {
    if (mobile.matches || !matchMedia('(hover: hover)').matches) return;
    const card = event.target.closest('.product-card-wrapper');
    card?.querySelectorAll('img[data-nonype-hover-src]').forEach((image) => {
      image.srcset = image.dataset.nonypeHoverSrcset;
      image.src = image.dataset.nonypeHoverSrc;
      delete image.dataset.nonypeHoverSrc;
      delete image.dataset.nonypeHoverSrcset;
    });
  }, { passive: true });
  window.NonypeResponsiveMedia = { loadWithin, observeGallery };
})();
